module.exports = __webpack_public_path__ + "img/calcSystemModel.e0b92f94.png";